<template>
  <div class="news-detail">
    <common-header :is-scrolled="true" />
    
    <div class="detail-container">
      <div class="news-content">
        <!-- 标题和日期 -->
        <h1 class="news-title">{{ $t('news.article55.title') }}</h1>
        <div class="news-date">{{ $t('news.article55.date') }}</div>

        <!-- 第一部分：第一张动图和文字 -->
        <div class="news-section">
          <img src="@/assets/xq/5.gif" alt="传统煤场" class="news-image" />
          <div class="news-text">
            <p class="highlight-text">{{ $t('news.article55.content.traditionalCoalYard.title') }}</p>
            <div class="feature-list">
              <p v-for="(feature, index) in $t('news.article55.content.traditionalCoalYard.features')" :key="index">{{ feature }}</p>
            </div>
          </div>
        </div>

        <!-- 第二部分：第二张动图 -->
        <div class="news-section">
          <img src="@/assets/xq/6.gif"  class="news-image" />
        </div>
        <div class="news-section">
          <img src="@/assets/xq/dt.gif"  class="news-image" style="max-width: 40%;"/>
        </div>
        <div class="news-text">
            <div class="feature-list">
              <p v-for="(intro, index) in $t('news.article55.content.smartPlatform.intro')" :key="index">{{ intro }}</p>
            </div>
        </div>
        <div class="news-section">
          <img src="@/assets/xq/7.jpg"  class="news-image" />
        </div>
        <div class="news-text">
            <div class="feature-list">
              <p v-for="(desc, index) in $t('news.article55.content.smartPlatform.description')" :key="index">{{ desc }}</p>
            </div>
        </div>
        <div class="news-section">
          <img src="@/assets/xq/dt.gif"  class="news-image" style="max-width: 40%;"/>
        </div>
      </div>
    </div>
    <div class="news-section">
          <div class="news-text">
            <p class="highlight-text">{{ $t('news.article55.content.skills.skill1.title') }}</p>
          <img src="@/assets/xq/8.jpg"  class="news-image" />
            <div class="feature-list">
              <p v-for="(desc, index) in $t('news.article55.content.skills.skill1.description')" :key="index">{{ desc }}</p>
            </div>
          </div>
    </div>
    <div class="news-section">
          <div class="news-text">
            <p class="highlight-text">{{ $t('news.article55.content.skills.skill2.title') }}</p>
          <img src="@/assets/xq/9.gif"  class="news-image" />
            <div class="feature-list">
              <p v-for="(desc, index) in $t('news.article55.content.skills.skill2.description')" :key="index">{{ desc }}</p>
            </div>
          </div>
    </div>
    <div class="news-section">
          <div class="news-text">
            <p class="highlight-text">{{ $t('news.article55.content.skills.skill3.title') }}</p>
          <img src="@/assets/xq/10.gif"  class="news-image" />
            <div class="feature-list">
              <p v-for="(desc, index) in $t('news.article55.content.skills.skill3.description')" :key="index">{{ desc }}</p>
            </div>
          </div>
    </div>
    <div class="news-section">
          <div class="news-text">
            <p class="highlight-text">{{ $t('news.article55.content.skills.skill4.title') }}</p>
          <img src="@/assets/xq/11.gif"  class="news-image" />
            <div class="feature-list">
              <p v-for="(desc, index) in $t('news.article55.content.skills.skill4.description')" :key="index">{{ desc }}</p>
            </div>
          </div>
    </div>
    <div class="news-section">
          <div class="news-text">
            <p class="highlight-text">{{ $t('news.article55.content.skills.skill5.title') }}</p>
          <img src="@/assets/xq/12.gif"  class="news-image" />
            <div class="feature-list">
              <p v-for="(desc, index) in $t('news.article55.content.skills.skill5.description')" :key="index">{{ desc }}</p>
            </div>
          </div>
    </div>
    <div class="news-section">
          <div class="news-text">
            <p class="highlight-text">{{ $t('news.article55.content.skills.skill6.title') }}</p>
          <img src="@/assets/xq/13.gif"  class="news-image" />
            <div class="feature-list">
              <p v-for="(desc, index) in $t('news.article55.content.skills.skill6.description')" :key="index">{{ desc }}</p>
            </div>
          </div>
    </div>
    <div class="news-section">
          <div class="news-text">
            <p class="highlight-text">{{ $t('news.article55.content.skills.skill7.title') }}</p>
          <img src="@/assets/xq/14.jpg"  class="news-image" />
          <img src="@/assets/xq/15.jpg"  class="news-image" />
            <div class="feature-list">
              <p v-for="(desc, index) in $t('news.article55.content.skills.skill7.description')" :key="index">{{ desc }}</p>
            </div>
          </div>
    </div>
    <div class="news-section">
          <div class="news-text">
          <img src="@/assets/xq/16.jpg"  class="news-image" style="margin-bottom: 10px;"/>
          <img src="@/assets/xq/17.jpg"  class="news-image" />
            <div class="feature-list">
              <p v-for="(skill, index) in $t('news.article55.content.skills.additionalSkills')" :key="index">{{ skill }}</p>
            </div>
          </div>
          <img src="@/assets/xq/18.jpg"  class="news-image" />
    </div>
    <div class="news-section">
          <img src="@/assets/xq/dt.gif"  class="news-image" style="max-width: 20%;"/>
        
        <div class="news-section">
          <div class="news-text">
          <div class="feature-list">
              <p v-for="(intro, index) in $t('news.article55.content.achievements.intro')" :key="index">{{ intro }}</p>
              <p v-for="(result, index) in $t('news.article55.content.achievements.results')" :key="'result-' + index">{{ result }}</p>
            </div>
            <img src="@/assets/xq/19.jpg"  class="news-image" />
          <div class="feature-list">
              <p v-for="(conclusion, index) in $t('news.article55.content.achievements.conclusion')" :key="index">{{ conclusion }}</p>
          </div>
          <img src="@/assets/xq/20.gif"  class="news-image" />
          </div>
    </div>
    </div>
    <common-section type="footer" />
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader.vue';
import CommonSection from '@/components/CommonSection.vue';

export default {
  name: 'NewsDetail55',
  components: { CommonHeader, CommonSection },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
    newsContent() {
      return {
        zh: `<h1>50亿项目落地！智佳能荣获2024年度最佳支持奖</h1>
<div class="news-meta">发布时间：2025-01-15</div>
<p>近日，智佳能收到来自宁德时代厦门项目基地的喜报，在交付的后段物流自动化生产线项目中，智佳能凭借丰富的项目经验和领先的技术水平以及高效的交付能力，<strong>斩获来自宁德时代颁发的2024年最佳支持奖、优秀项目经理以及优秀个人多项殊荣。</strong></p>
<p>据悉，该项目作为百亿量级的省重点项目，一期总建筑面积124万平方米，主要建设两栋主厂房及其他生产配套设施，规划产能60GWh的新能源电池生产线。项目建成后将进一步扩大厦门市新能源动力电池产业规模，并带动产业上下游配套企业来厦落地。</p>
<p><strong>以创新为基石 成就锂电智能物流典范</strong></p>
<p>作为宁德时代厦门锂电池制造基地一期高速线后段物流自动化核心集成商，智佳能展示了卓越的技术实力和自主研发能力。为满足宁德时代高速线的高技术要求，<strong>智佳能首次采用行业领先的磁悬浮柔性输送系统，将生产节拍从传统的0.5m/s提升至1m/s以上，精度达0.05mm。</strong>此外，智佳能创新性地使用了嵌套式连续提升机，比传统往复式提升机快240%，完美满足宁德时代超高产能需求。</p>
<p><strong>齐心协力为项目 争分夺秒保交付</strong></p>
<p>在宁德时代厦门项目一期合作中，智佳能与宁德时代厦门团队紧密协作，共同攻克了一个又一个技术难关。智佳能在项目中扮演重要角色，从设备研发到调试交付，为项目提供了全方位的支持。</p>
<p>在该项目投产前，项目小组面临了开发技术难度大、时间紧迫等多重挑战。大家以极高的执行力和配合度迎难而上，多方有序协调。工程师们深知测试是创新性产品走出公司，正式迈向市场的关键环节，他们耐心认真、心怀敬畏地反复测试，不放过任何细节的精准把控，努力做到极致。</p>
<p>据悉，<strong>该项目是智佳能在电芯自动化高速线上赢得的首个项目，凭借卓越的性能和技术实力，智佳能陆续斩获宁德时代等龙头锂电企业数个项目订单。</strong></p>
<p>多年来，智佳能始终秉承"客户至上"的服务理念。行业与客户的每一次嘉奖，都是对智佳能的认可与信任。未来，智佳能将继续保持初心，不懈努力，致力于为客户创造更大价值，为新能源行业的蓬勃发展贡献自己的力量。</p>`,
        en: `<h1>5 Billion Project Lands! ZOCONO Wins 2024 Best Support Award</h1>
<div class="news-meta">Release Date: 2025-01-15</div>
<p>Recently, ZOCONO received good news from the Xiamen Times project base of CATL. In the delivered back-end logistics automation production line project, ZOCONO, with its rich project experience, leading technical level and efficient delivery capability, won multiple honors including the 2024 Best Support Award, Excellent Project Manager and Excellent Individual from CATL.</p>
<p>It is reported that this project, as a provincial key project with a scale of over 10 billion yuan, has a total construction area of 1.24 million square meters in its first phase. It mainly involves the construction of two main production plants and other production supporting facilities, with a planned production capacity of 60GWh for new energy battery production lines. After its completion, it will further expand the scale of the new energy battery industry in Xiamen and drive the settlement of upstream and downstream supporting enterprises in the city.</p>
<p><strong>Innovation as the Foundation, Creating a Model of Intelligent Logistics for Lithium Batteries</strong></p>
<p>As a leading provider of high-speed line post-process logistics automation for the first phase of the Xiamen CATL Battery Manufacturing Base project, ZOCONO has demonstrated outstanding technical strength and independent R&D capabilities. To meet the high technical requirements of CATL's high-speed lines, <strong>ZOCONO has for the first time adopted an industry-leading magnetic levitation flexible transportation system, increasing the production pace from the traditional 0.5m/s to over 1m/s, with an accuracy of 0.05mm.</strong> Additionally, ZOCONO innovatively used a nested continuous lifting machine, which is 240% faster than the traditional reciprocating lifting machine, perfectly meeting CATL's ultra-high production capacity demands.</p>
<p><strong>Working Together for the Project, Striving for On-time Delivery</strong></p>
<p>In the cooperation of the first phase of the Xiamen CATL project, ZOCONO worked closely with the Xiamen CATL team, jointly overcoming one technical challenge after another. Playing a significant role in the project, ZOCONO provided comprehensive support from equipment research and development to commissioning and delivery.</p>
<p>Before the project's production, the project team faced multiple challenges including high technical difficulty and tight deadlines. With high execution capability and coordination, the team overcame difficulties through orderly coordination. The engineers, understanding that testing is a crucial step for innovative products to enter the market, conducted repeated tests with patience and reverence, ensuring precise control of every detail to achieve perfection.</p>
<p>It is reported that <strong>this project is the first project that ZOCONO has won on the automated high-speed line for battery cells. With its excellent performance and technical strength, ZOCONO has successively won several project orders from leading lithium battery companies such as CATL.</strong></p>
<p>Over the years, ZOCONO has always adhered to the service philosophy of "customer first". Every award from the industry and customers is recognition and trust in ZOCONO. In the future, ZOCONO will continue to maintain its original aspiration, work tirelessly, and strive to create greater value for customers and contribute to the vigorous development of the new energy industry.</p>`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.news-detail {
  .detail-container {
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 100px;
    padding: 40px 20px;
  }

  .news-content {
    background: #fff;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  .news-title {
    font-size: 32px;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
    font-weight: 600;
  }

  .news-date {
    text-align: center;
    color: #666;
    margin-bottom: 40px;
    font-size: 16px;
  }

  .news-section {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .news-image {
    width: 100%;
    max-width: 800px;
    height: auto;
    margin: 0 auto;
    display: block;
    border-radius: 8px;
  }

  .news-text {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    text-align: center;
    margin: 20px 0;
  }

  .highlight-text {
    font-size: 24px;
    font-weight: 600;
    color: #1d2088;
    margin-bottom: 20px;
  }

  .feature-list {
    p {
      font-size: 20px;
      margin: 10px 0;
      color: #333;
    }
  }

  .back-link {
    text-align: center;
    margin-top: 40px;
    
    a {
      color: #1d2088;
      text-decoration: none;
      font-size: 16px;
      display: inline-block;
      padding: 8px 20px;
      border: 1px solid #1d2088;
      border-radius: 4px;
      transition: all 0.3s ease;

      &:hover {
        background: #1d2088;
        color: #fff;
      }
    }
  }
}

@media (max-width: 768px) {
  .news-detail {
    .detail-container {
      padding: 20px;
    }

    .news-content {
      padding: 20px;
    }

    .news-title {
      font-size: 24px;
    }

    .highlight-text {
      font-size: 20px;
    }

    .feature-list p {
      font-size: 18px;
    }
  }
}
</style> 